import {
    IUserSubscriptionsObject,
    subscriptionPreferencesAT,
} from "../subscriptionPreferences/SubscriptionPreferencesModel";

export function subscriptionsReducer(
    state: IUserSubscriptionsObject = {},
    action
): IUserSubscriptionsObject {
    switch (action.type) {
        case subscriptionPreferencesAT.hasConsents:
            return action.userSubscriptionsObject;

        case subscriptionPreferencesAT.subscriptionChange:
            const id = action.consentId;
            const s = state[id];
            return {
                ...state,
                [id]: { ...s, [action.consentKey]: action.value },
            };

        default:
            return state;
    }
}
